export default "__VITE_ASSET__0ab86100__"